import * as Phaser from 'phaser';
import type { Triangulate } from '../../sim/map/index.ts';

/**
 * Phaser's bundled Earcut, in the shape `TriMeshBuilder` wants. The sim builder takes the
 * triangulator as an argument so `src/sim` stays Phaser-free (tests inject a fan).
 */
export const earcutTriangulate: Triangulate = (flat) => Phaser.Geom.Polygon.Earcut(flat);
